import React from "react";
import { connect } from "react-redux";
import { useEffect, useState, useRef } from "react";
import axios from "axios";

const Band = (props) => {
  const { isSuperAdmin, isAdmin, isGuide } = props;

  const inputText = useRef(null);
  const [edit, setEdit] = useState(false);
  const [bandText, setText] = useState("");

  const config = {
    headers: {
      Authorization: ` Bearer ${localStorage.getItem("token")}`,
    },
  };
  const setBandMessage = async (e) => {
    if ((e.key === "Enter" || e.type === "blur") && bandText.length > 0) {
      setEdit(false);
      try {
        await axios.post(
          process.env.REACT_APP_URL_API + "/api/settings/message",
          {
            message: bandText,
          },
          config
        );
      } catch (error) {}
    } else if (
      (e.key === "Enter" || e.type === "blur") &&
      bandText.length === 0
    ) {
      setEdit(false);
      try {
        await axios.delete(
          process.env.REACT_APP_URL_API + "/api/settings/message/1",
          config
        );
      } catch (error) {}
    }
  };
  const getBandMessage = async () => {
    try {
      const response = await axios.get(
        process.env.REACT_APP_URL_API + "/api/settings"
      );
      if (response.data.data[0].message) {
        setText(response.data.data[0].message);
      } else {
        setText("");
      }
    } catch (error) {}
  };

  const onInputOut = (e) => {
    setEdit(false);
    setBandMessage(e);
  };

  useEffect(() => {
    // getBandMessage();
  }, []);

  return (
    <>
      {(isSuperAdmin || isAdmin || isGuide) && (
        <div
          className="band px-4"
          onDoubleClick={() => setEdit(!edit)}
          onKeyDown={(e) => setBandMessage(e)}
        >
          {edit ? (
            <input
              className="text"
              type="text"
              ref={inputText}
              onMouseOver={() => inputText.current.focus()}
              style={{ color: "black" }}
              value={bandText}
              onChange={(e) => setText(e.target.value)}
              onBlur={(e) => onInputOut(e)}
            />
          ) : (
            <p className="text">{bandText}</p>
          )}
        </div>
      )}
      {bandText && !isSuperAdmin && !isAdmin && !isGuide && (
        <div className="band">
          <p className="text">{bandText}</p>
        </div>
      )}
    </>
  );
};

const mapStateToProps = (state) => state.auth;

export default connect(mapStateToProps)(Band);
